module.exports = __webpack_public_path__ + "img/bus.9346ea6a.svg";